
export const getGraphQlItems = () => {
    return ["fund_name", "category", "sub_category", "scheme_name", "scheme_type", "fund_house", "plan_type", "amc", "aum", "holding", "expense_ratio"]
}

export const getColumns = (filters) => {
    return [
        {
            title: "Sr",
            key: "sr",
            width: 60,
            fixed: "left",
            render: ((value, item, index) => index + 1)
        },
        {
            title: 'Fund Name',
            dataIndex: 'fund_name',
            key: 'fund_name',
            filterSearch: true,
            filteredValue: filters["fund_name"],
            fixed: "left"
        },
        {
            title: 'Fund House',
            dataIndex: 'fund_house',
            key: 'fund_house',
            filterSearch: true,
            filteredValue: filters["fund_house"]
        },

        {
            title: 'Category',
            dataIndex: 'category',
            key: 'category',
            filterSearch: true,
            filteredValue: filters["category"],
            width: 100

        },
        {
            title: 'Sub Category',
            dataIndex: 'sub_category',
            key: 'sub_category',
            filterSearch: true,
            filteredValue: filters["sub_category"]
        },

        {
            title: 'Expense Ratio',
            dataIndex: 'expense_ratio',
            key: 'expense_ratio',
            sorter: true
        },
        {
            title: 'Holding',
            dataIndex: 'holding',
            key: 'holding',
            sorter: true
        },
        {
            title: 'Nav Start',
            dataIndex: 'start',
            key: 'start',
            render: ((d) => {
                return d ? d.toFixed(2) : d
            }),
        },
        {
            title: 'Nav End',
            dataIndex: 'end',
            key: 'end',
            render: ((d) => {
                return d ? d.toFixed(2) : d
            }),
        },
        {
            title: 'Nav Start Date',
            dataIndex: 'startDate',
            key: 'startDate',
            sorter: (a, b) => new Date(a.startDate) - new Date(b.startDate),
            width: 115
        },
        {
            title: 'Nav End Date',
            dataIndex: 'endDate',
            key: 'endDate',
            width: 115
        },
        {
            title: 'Fund Size',
            dataIndex: 'aum',
            key: 'aum',
            sorter: true,
            render: ((d) => {
                return d ? d.toFixed(2) : d
            }),
        },
        {
            title: 'Returns(%)',
            dataIndex: "returns",
            key: "returns",
            sorter: (a, b) => a.returns - b.returns,
        },
        {
            title: 'C.I.(% Per Year)',
            dataIndex: "ci",
            key: "ci",
            // fixed: 'right',
            sorter: (a, b) => a.ci - b.ci,
        }

    ]
}